export const ADD_ROLE = "ADD_ROLE"
export const GET_ROLE = "GET_ROLE"
export const ALL_ROLE = "ALL_ROLE"
export const EDIT_ROLE = "EDIT_ROLE"
export const GET_ROLEPERMISSION = "GET_ROLEPERMISSION";
export const ALL_ROLEPERMISSION = "ALL_ROLEPERMISSION";
export const EDIT_ROLEPERMISSION = "EDIT_ROLEPERMISSION";




